import { MapContainer, TileLayer, Polygon, Marker, Tooltip } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Fix the default Leaflet marker icon (webpack bundling breaks the default URLs)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const containerStyle = { width: "100%", height: "460px", borderRadius: "16px" };

const polygonOptions = {
  color: "#7ABC32",
  fillColor: "#7ABC32",
  fillOpacity: 0.18,
  weight: 2,
  opacity: 0.9,
};

/**
 * Reusable Leaflet/OpenStreetMap showing a tinted polygon for the service area
 * plus a marker at every suburb in the region.
 *
 * Props:
 *   areaKey - unique string for re-render keys
 *   center  - { lat, lng } map center
 *   zoom    - number
 *   polygon - array of { lat, lng } - traced clockwise
 *   suburbs - array of { name, position: { lat, lng } }
 */
export default function ServiceAreaMap({ areaKey, center, zoom = 11, polygon, suburbs = [] }) {
  const centerArr = [center.lat, center.lng];
  const polygonArr = polygon.map((p) => [p.lat, p.lng]);

  return (
    <div
      className="rounded-2xl overflow-hidden shadow-md border border-slate-200"
      style={{ height: containerStyle.height }}
      data-testid={`service-area-map-${areaKey}`}
    >
      <MapContainer
        center={centerArr}
        zoom={zoom}
        scrollWheelZoom={false}
        style={containerStyle}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Polygon positions={polygonArr} pathOptions={polygonOptions} />
        {suburbs.map((s) => (
          <Marker key={`${areaKey}-${s.name}`} position={[s.position.lat, s.position.lng]}>
            <Tooltip permanent={false} direction="top" offset={[0, -32]}>
              {s.name}
            </Tooltip>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
